import React,{useState, Fragment} from 'react';
import "./index.css";

function HomeNewsItem(props) {
    
    return (
        <Fragment>
            
                <div className={`team-mem-item ${props.isActive ? "active-slide" : ""}`} style={{margin:"5%"}} >
                    
                    <figure className="product-pic" style={{maxWidth:'100%'}}>
                        {/* <Link to={`${localhost:3000 + teamMemberURl}`}> */}
                            <img src={`${ process.env.REACT_APP_BASE_URL+ props.newsImage}`} alt={props.name} style={{maxHeight:"200px"}}/>
                        {/* </Link> */}
                    </figure>
                    <div className="product-info" style={{maxHeight:"120px", minHeight:"90px"}}>
                        <h6>{props.newsTitle}</h6>
                        {/* <span className="designation">{props.displayText}</span> */}
                    </div>
                </div>
            {/* )} */}
        </Fragment>
    );
}

export default HomeNewsItem;